import { render } from "./TableWithFixedColumnsAndHeader.vue?vue&type=template&id=66d6a1ee"
import script from "./TableWithFixedColumnsAndHeader.vue?vue&type=script&lang=ts"
export * from "./TableWithFixedColumnsAndHeader.vue?vue&type=script&lang=ts"
script.render = render

export default script